import { call, put, takeLatest } from 'redux-saga/effects'
import { StatsActions, StatsTypes } from './statsSlice'
import api from '../../services/api'

function* fetchPublicStatsSaga() {
  const response = yield call(api.getPublicStats)
  if (response.ok) {
    yield put(StatsActions.fetchPublicStatsSuccess(response.data))
  } else {
    yield put(StatsActions.fetchPublicStatsFailure(response.problem))
  }
}

export default function* statsSaga() {
  yield takeLatest(StatsTypes.FETCH_PUBLIC_STATS_REQUEST, fetchPublicStatsSaga)
}
